import { render, staticRenderFns } from "./features-course.vue?vue&type=template&id=d5492934&"
import script from "./features-course.vue?vue&type=script&lang=js&"
export * from "./features-course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports